var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7551 20.711L19.8432 16.245C19.611 16.034 19.3059 15.9215 18.9923 15.9312C18.6787 15.9408 18.3811 16.072 18.1624 16.297L15.2709 19.2707C14.5749 19.1378 13.1756 18.7016 11.7353 17.2649C10.295 15.8233 9.85877 14.4205 9.72947 13.7293L12.7008 10.8365C12.926 10.618 13.0574 10.3204 13.0671 10.0067C13.0768 9.69296 12.964 9.3878 12.7527 9.15575L8.28793 4.24508C8.07653 4.01231 7.7827 3.87111 7.46887 3.85148C7.15503 3.83185 6.84591 3.93534 6.60714 4.13996L3.98506 6.38867C3.77615 6.59833 3.65146 6.87738 3.63464 7.17287C3.61652 7.47496 3.27093 14.6307 8.8196 20.1818C13.6602 25.0212 19.7236 25.3752 21.3935 25.3752C21.6376 25.3752 21.7874 25.368 21.8273 25.3655C22.1228 25.349 22.4017 25.2238 22.6103 25.0139L24.8578 22.3906C25.0632 22.1526 25.1675 21.8437 25.1483 21.5299C25.1291 21.2161 24.988 20.9222 24.7551 20.711Z",
    fill: "#FF5467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBs);
export default __webpack_public_path__ + "static/media/PhoneBS.2e4fd8fbc99aaef89b49962bba47d988.svg";
export { ForwardRef as ReactComponent };